import React, { Component } from "react";
import { Card } from "react-bootstrap";
import configData from "../../config.json";

/**
 * KPICardAdapter - KPI card with count/sum/trend display.
 * Full implementation in Phase 7.
 */
export default class KPICardAdapter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
      loading: true,
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
    };
  }

  componentDidMount() {
    this.fetchKPIData();
  }

  fetchKPIData = () => {
    const { config } = this.props;
    if (!config.apiEndPoint) {
      this.setState({ loading: false });
      return;
    }

    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + config.apiEndPoint, {
      method: config.apiMethod || "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const chartConfig = config.chartConfig || {};
          const list = data.list || [];
          let value = list.length;

          if (chartConfig.aggregation === "sum" && chartConfig.valueField) {
            value = list.reduce((sum, row) => sum + (parseFloat(row[chartConfig.valueField]) || 0), 0);
          } else if (chartConfig.aggregation === "avg" && chartConfig.valueField) {
            const sum = list.reduce((s, row) => s + (parseFloat(row[chartConfig.valueField]) || 0), 0);
            value = list.length > 0 ? (sum / list.length).toFixed(2) : 0;
          }

          this.setState({ value, loading: false });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => this.setState({ loading: false }));
  };

  render() {
    const { config } = this.props;
    const { value, loading } = this.state;
    const chartConfig = config.chartConfig || {};

    return (
      <Card className="text-center mb-3" style={{ borderLeft: `4px solid ${chartConfig.color || "#0d6efd"}` }}>
        <Card.Body>
          {chartConfig.icon && <i className={`${chartConfig.icon} mb-2`} style={{ fontSize: "2rem", color: chartConfig.color || "#0d6efd" }}></i>}
          <Card.Title style={{ fontSize: "0.875rem", color: "#6c757d" }}>
            {config.instanceName || "KPI"}
          </Card.Title>
          <div style={{ fontSize: "2rem", fontWeight: "bold", color: chartConfig.color || "#0d6efd" }}>
            {loading ? "..." : (chartConfig.prefix || "") + Number(value).toLocaleString() + (chartConfig.suffix || "")}
          </div>
          {chartConfig.description && (
            <Card.Text className="text-muted" style={{ fontSize: "0.75rem" }}>
              {chartConfig.description}
            </Card.Text>
          )}
        </Card.Body>
      </Card>
    );
  }
}
